import { Circle } from "lucide-react";
import { RUNTIME_META, type RuntimeState } from "@/lib/status";
import { StatusBadge } from "./StatusBadge";

export function RuntimePill({ state, version, iconOnly }: { state: RuntimeState; version?: string; iconOnly?: boolean }) {
  const m = RUNTIME_META[state];
  const text = state === "connected" && version ? `${m.text} · v${version}` : m.text;
  if (iconOnly)
    return (
      <StatusBadge tone={m.tone} label={<span className="sr-only">{text}</span>} icon={Circle} className="px-1.5 [&_svg]:fill-current" />
    );
  return <StatusBadge tone={m.tone} label={text} icon={Circle} className="[&_svg]:size-2 [&_svg]:fill-current" />;
}
